import React from 'react';
import { Pane, Flex, Text } from '@leverege/ui-elements';
import ColorOption, { options } from '../../../views/pairing/editor/ColorOption';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SwatchAndColor(props) {
  const {
    variant = 'detailValue',
    object,
    style,
    swatchStyle = {
      width: 20,
      height: 20
    }
  } = props;
  let {
    colorName,
    value
  } = props;
  if (!colorName) {
    colorName = object?.data?.data?.colorName || options.find(opt => opt.value === object?.data?.data?.color)?.name;
  } else {
    value = options.find(opt => opt.name === colorName)?.value;
  }
  if (!colorName) {
    return '--';
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "tableCellContent",
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowS",
      align: "center",
      style: style,
      children: [/*#__PURE__*/_jsx(ColorOption, {
        option: {
          value
        },
        style: swatchStyle
      }), /*#__PURE__*/_jsx(Text, {
        variant: variant,
        children: colorName
      })]
    })
  });
}